exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-title[data-v-1152afd4] {\n  font-size: 24px;\n}\n.modal-content[data-v-1152afd4] {\n  height: 100%;\n}\n.modal-footer[data-v-1152afd4] {\n  max-width: 80%;\n  width: 100%;\n  display: inline-block;\n  text-align: left;\n}\n", ""]);

// exports
